//import { put, call } from "redux-saga/effects";

import actions from "../actions";
import { filterBySourceDest } from "../global-services";
import { useDispatch, useSelector } from "react-redux";
import { get } from "../../xhr.js";



//import FlightJSON from "../mocks/flights-one-way-mumbai.json";
function sortFunction(a,b){
    var dateA = new Date(a.updated).getTime();
    var dateB = new Date(b.updated).getTime();
    return dateA > dateB ? 1 : -1;
};

export async function fetFlightList(payload,dispatch,tries) {




  // put API URL here
  let json1 ={};
  let json2 ={};
  let json3 ={};
  let json4 ={};
  let flight_info_json={};
  let response1  ={};
  let response2  ={};
  let response3  ={};
  let response4  ={};
  let flight_info_response  ={};

  console.log(payload)
  let scheduleurl="https://airlabs.co/api/v9/schedules?api_key=f250f4ba-57ad-462c-b988-e669aa89d652&flight_icao=" +
  payload.source + payload.flightnum;
  let url1 = ""

  if (payload.tripType=="tailnumber")
    url1="https://airlabs.co/api/v9/flights?api_key=f250f4ba-57ad-462c-b988-e669aa89d652&reg_number=" +
    payload.regnumber;
  else
   url1= "https://airlabs.co/api/v9/flights?api_key=f250f4ba-57ad-462c-b988-e669aa89d652&flight_iata=" +
    payload.iata + payload.flightnum;


  let flight_info_url="https://airlabs.co/api/v9/flight?6492&api_key=f250f4ba-57ad-462c-b988-e669aa89d652&flight_iata="+
    payload.iata + payload.flightnum;



  let url2 =""

  if (payload.tripType=="tailnumber")
    url2="https://airlabs.co/api/v9/fleets?api_key=f250f4ba-57ad-462c-b988-e669aa89d652&reg_number="+
    payload.regnumber;
  else
    url2= "https://airlabs.co/api/v9/routes?api_key=f250f4ba-57ad-462c-b988-e669aa89d652&airline_icao=" +
    payload.source +
    "&flight_number=" +
    payload.flightnum;






  //const jsonResponse = [...FlightJSON];
  try {


    console.log(url1);
    console.log(url2);
    console.log(scheduleurl);





    response1 = await fetch(url1);
    json1 = await response1.json();

    console.log(json1);
    if ('response' in json1)
    {
      if (json1['response'].length>0)
      {
          if (!json1['response'][0])
                json1="";
          else
          {
                json1=json1['response'][0]
                if (payload.tripType=="tailnumber")
                    json1['type']="regnumber";
                if (payload.tripType=="flightnumber")
                  {

                            var fleet_url="https://airlabs.co/api/v9/fleets?api_key=f250f4ba-57ad-462c-b988-e669aa89d652&reg_number="+
                           json1['reg_number'];

                           var fleet_response = await fetch(fleet_url);
                            console.log(fleet_url)
                           var json_fleet = await fleet_response.json();
                          console.log(json_fleet)
                           json_fleet=json_fleet['response']['0']


                  }
          }
      }
      else {
            json1="";
      }
    }
    else {

        json1="";
    }


     response2 = await fetch(url2);
     json2 = await response2.json();



    var array;
    array=json2['response'].sort(sortFunction);

    if (array.length>1)
    {
      console.log("more than 2 routes")
      if (tries==1)
        json2=array[array.length-1]
      else
      if (tries==2)
        json2=array[array.length-2]

      console.log(json2)

    }
    else {
        if (array.length==0)
        {
             console.log("no routes")

             console.log(flight_info_url);
             flight_info_response = await fetch(flight_info_url);
             flight_info_json = await flight_info_response.json();

             if (!flight_info_json['response'])
             {
               //alert("dudu")
               flight_info_json=""
               json2=""
             }
             else
             {

               flight_info_json=flight_info_json['response'];
                json2=flight_info_json;
                if (payload.tripType=="tailnumber")
                  json2['type']="regnumber";


            //    console.log(json2)
             }
        }
        else
        {
          console.log("1 routes")
          json2=json2['response'][0];


        }
    }

    if (json2!="")
    if (payload.tripType=="tailnumber")
        json2['type']="regnumber";






    //console.log("DUDUD")
    let airport =""

    if (payload.tripType=="flightnumber")
    if (json2)
        airport =
           "https://airlabs.co/api/v9/airports?&api_key=f250f4ba-57ad-462c-b988-e669aa89d652&iata_code=" +
           json2.dep_iata
    else
       airport =
          "https://airlabs.co/api/v9/airports?&api_key=f250f4ba-57ad-462c-b988-e669aa89d652&iata_code=" +
          json1.dep_iata

    if (payload.tripType=="flightnumber")
    {
      console.log(airport);
      response4 = await fetch(airport);
      json4 = await response4.json();

      json4=json4['response'][0]
    }



    console.log(flight_info_url);



    json3=""
    if (payload.tripType=="flightnumber")
    {
      response3 = await fetch(scheduleurl);
      json3 = await response3.json();
      if (!json3['response'][0])
        json3=""
      else
      json3=json3['response'][0];
    }
    //console.log(json3);





    console.log(json1);
    console.log(json2);
    console.log(json3);
    console.log(json4);
    console.log(flight_info_json)
    console.log(fleet_response);

    const jsonresponse = [json1,json2,json3,json4,flight_info_json,json_fleet];

  //  console.log(jsonresponse);
    //return;

    console.log(json2);


      if (payload.tripType=="flightnumber")
        if (json2=="" || !(json4.timezone) )
        {

          throw Error("No Records Found");
        }

      if (payload.tripType=="tailnumber")
      if (json2=="" )
      {

        throw Error("No Records Found");
      }




    //const response = filterBySourceDest(payload, jsonResponse);

    dispatch({
      type: actions.GET_FLIGHT_LIST_SUCCESS,
      result: jsonresponse,
      error: null
    });
  } catch (error) {

    console.log(error.message);
    const errorObj = error.message;

    dispatch({
      type: actions.GET_FLIGHT_LIST_ERROR,
      result: null,
      error: {
        statusCode: errorObj,
        message: errorObj
      }
    });



  }
}
